/**
 * Tipos de servicio del ERP (2026-10-13, pedido de Erwin: select en vez de
 * texto libre). Los márgenes del acuerdo comercial usan las modalidades de la
 * cotización; la ficha del cliente admite además "ambos" (mixed).
 *
 * normalizeServiceType reconoce los textos que se escribían antes
 * ("Servicios Transitorios", "EST", "Outsourcing"…). Devuelve el código, ''
 * si viene vacío, o null si no lo reconoce (queda como valor antiguo para que
 * el usuario elija). Mismo criterio que normalizeServiceMode del backend
 * (controllers/erpQuotation.controller.js), que hereda el margen.
 */
export const SERVICE_MODES = ['temporary_services', 'outsourcing'];
export const CLIENT_SERVICE_TYPES = [...SERVICE_MODES, 'mixed'];

export const normalizeServiceType = (value, { allowMixed = false } = {}) => {
  const text = String(value || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
  if (!text) return '';
  if (SERVICE_MODES.includes(text) || (allowMixed && text === 'mixed')) return text;
  const isEst = /transitori|temporary|\best\b/.test(text);
  const isOut = /outsourc|subcontrat|\bout\b/.test(text);
  if (isEst && !isOut) return 'temporary_services';
  if (isOut && !isEst) return 'outsourcing';
  if (allowMixed && ((isEst && isOut) || /mixt|ambos|both|mixed/.test(text))) return 'mixed';
  return null;
};

// Valor para el select: el código si se reconoce; si no, el texto antiguo tal cual
export const toServiceTypeValue = (value, options) => {
  const code = normalizeServiceType(value, options);
  return code === null ? String(value) : code;
};
